<div class="player-banner" *ngIf="isPlayerRoute && player">
  <div class="banner-content">
    <div class="venue-name">{{player?.venue?.name}}</div>
    <div class="serial-number">Serial: {{player?.serialNumber}}</div>
  </div>
</div>
